import React from 'react';

import SavingsTypesContainer from '@totem/components/administration/optimize/savingsTypes/savingsTypesContainer';
import SavingsTypesLayout, {
  SavingsTypesExtra,
} from '@totem/components/administration/optimize/savingsTypes/savingsTypesLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const SavingsTypesPage = () => (
  <ContentLayout>
    <SavingsTypesContainer>
      <IBCard
        isCovered
        title="Optimize Savings Types"
        extra={<SavingsTypesExtra />}
      >
        <SavingsTypesLayout />
      </IBCard>
    </SavingsTypesContainer>
  </ContentLayout>
);

export default SavingsTypesPage;
